import { PPCustomerInfo } from "@/picking-portal/models/PPCustomerInfo";
import { httpService } from "@/common/services/HttpService";

class PPUserService {
  async getUserInfo(userId: string): Promise<PPCustomerInfo> {
    const { data } = await httpService
      .getInstance()
      .get<PPCustomerInfo>(`/api/v1/backoffice/admin/users/${userId}/contact-info`);
    return data;
  }
}

export const userService = new PPUserService();
